import { LinkTo } from '@ember/routing';
import { t } from 'ember-intl';
import Svg from 'tio-employee/components/svg';
import Tile from '../tile';

<template>
  <LinkTo @route="authenticated.lpn.index">
    <Tile @headerText="Learning Partner Network">
      <:description>
        {{t "lpn.tile.description"}}
      </:description>
      <:image>
        <Svg
          @name="lpn-tile"
          width="100%"
          height="100%"
          role="img"
          aria-label={{t "svg.lpn_tile"}}
        />
      </:image>
    </Tile>
  </LinkTo>
</template>
